<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'banner/index' }">
                                Banner
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            List Banner
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="col-auto">
                <router-link v-bind:to="{ name: 'banner/add' }" class="btn btn-danger btn-sm font-weight-medium mt-4 mb-2">
                    Create New Banner +
                </router-link>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6" v-for="banner in banners" v-bind:key="banner.id">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Banner # {{ banner.priority }}
                                </span>
                            </div>
                            <div class="col-auto">
                                <router-link v-bind:to="{name: 'banner/edit', params: {id: banner.id}}" class="btn btn-link h4 p-0 my-0 mr-2">
                                    Edit
                                </router-link>
                                <button class="btn btn-link h4 p-0 my-0" v-on:click="confirmation(banner)">
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <img v-bind:src="banner.imageUrl" class="img-fluid mb-2 rounded w-100" />
                        <div class="text-muted">
                            Judul Banner:
                        </div>
                        <p class="card-text font-weight-bold">
                            {{ banner.title }}
                        </p>
                        <div class="text-muted">
                            Teks Banner:
                        </div>
                        <p class="card-text">
                            {{ banner.description }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        
        <b-modal v-model="modalShow" v-on:hide="removeReference = null" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus banner ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="remove">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modalShow = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    export default {
        name: "BannerIndex",
        data() {
            return {
                modalShow: false,
                removeReference: null,
                banners: [{}, {}, {}, {}, {}]
            };
        },
        methods: {
            confirmation(model) {
                this.modalShow = true;
                this.removeReference = model;
            },
            remove() {
                if (this.removeReference) {
                    this.axios.post(process.env.API_URL + '/banner/delete/' + this.removeReference.id).then(response => {
                        if (response.data.status) {
                            this.$toastr('success', response.data.message, 'Success');
                            this.fetchBanner();
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                        this.modalShow = false;
                        this.removeReference = null;
                    });
                }
            },
            fetchBanner() {
                this.axios.get(process.env.API_URL + '/banner').then(response => {
                    this.banners = response.data.data;
                });
            }
        },
        created() {
            this.fetchBanner();
        },
        mounted() {
            document.title = 'List Banner - ' + process.env.APP_NAME;
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/banner/Index.vue